import React, { useEffect, useMemo, useRef, useState } from 'react';
import PurchserUserAPI from 'lib/Core/Backend/Controllers/PurchaserUserAPI';
import Notify from 'lib/Utils/Alert';
import NotificationAlert from "react-notification-alert";
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import { Alert, Button, Card, CardBody, Col, Container, FormText, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Link } from '@mui/material';
import FileUpload from "lib/Core/Backend/Controllers/FileUpload";
import AuthData from "../../lib/Core/AuthData";
import PurchaserAuth from "../../lib/Core/Backend/Controllers/PurchaserAuth";
import Spinner from 'react-bootstrap/Spinner';
const securityGroups = [
  "purchaser"
]
const Keys = (props) => {

  
  const { token , purchaserId} = props;
  const purchaserAPIctl = useMemo(() => new PurchserUserAPI(token), [token]);
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const authData = new AuthData(securityGroups);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const toggle = () => setModal(!modal)
  const toggleConfirm = () => setConfirmModal(!confirmModal);
  const [credentialsOperation, setCredentialsOperation] = useState('Generate');
  const [access, setAccess] = useState('');
  const [secretKey,setSecretKey] = useState('');
  const supplierCtl = useMemo(() => new FileUpload(token), [token]);
 const [generateLoader,setRegenerateLoader] = useState(false);
  const [credentialLoader,setCredentialLoader] = useState(false);
  const auth = new PurchaserAuth(authData.token);


  const alert = useRef();
 

  const fetchPurchaserData = ()=> {
    
    purchaserCtl.purchaserCheck(purchaserId, (data) => {
      if (data && !data.error) {
        if(data?.users[0]?.enabled == false){
          sessionStorage.removeItem("accessToken")
            window.location.href="purchaser-auth/login"
    }
        
      }else{
       if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){

          Notify(alert, 'danger', data?.errorMessage ?? data?.error);
              sessionStorage.removeItem("accessToken")
              window.location.href="purchaser-auth/login"
          }
          if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
    
            Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
            }
      }
})
}


useEffect(()=>{    
fetchPurchaserData();

},[purchaserId])

  const generateCredentials = () => {
    setCredentialLoader(true)
    if (credentialsOperation === 'Generate') {
      setTimeout(() => {
        setCredentialLoader(false)
      }, 1500);
      toggle();
      purchaserAPIctl.createUser((data) => {
        setAccess(data.access);
        setSecretKey(data?.secret)
        setCredentialsOperation('Regenerate')
      })

    } else {
      toggleConfirm();
      setTimeout(() => {
        setCredentialLoader(false)
      }, 1500);
    }
  }

  const confirmRegeneration = (e) => {
    setRegenerateLoader(true)
    e.preventDefault();
    e.target.disabled = true;
    if(access === "" || access === undefined){
      Notify(alert,"danger", "access key is not avaibale to regenerate");
      setRegenerateLoader(false)
      e.target.disabled = false;
      return
    }
    purchaserAPIctl.resetPassword(access, data => {
      if (data.error || data.errorMessage) {
        setTimeout(() => {
          setRegenerateLoader(false)
        }, 1500);
        Notify(alert, 'danger', data.errorMessage ?? data.error);
      } else {
        e.target.disabled = false;
        toggleConfirm();
        toggle();
        setTimeout(() => {
          setRegenerateLoader(false)
        }, 1500);
        setSecretKey(data?.secret)
      }
    })
  }

  const copy = async (e) => {
    
    e.target.disabled = true;
      await navigator.clipboard.writeText(secretKey);
      Notify(alert, 'info', 'Secret key copied')
   e.target.disabled = false;
  }

  const copyAccess = async (e) =>{
   await navigator.clipboard.writeText(access);
   Notify(alert, 'info', 'Access key copied')
  }

  useEffect(() => {
    if (props.token) {

      purchaserAPIctl.userDetails(data => {
        if (data.errorCode === 'NOT_FOUND') {
          setCredentialsOperation('Generate')
        } else {
          setCredentialsOperation('Regenerate');
          setAccess(data.access)
        }
      })
    }
  }, [props, purchaserAPIctl])

  const downloadTermsandCondition = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const downloadFile = (FileType) => {
    supplierCtl.downloadPDFDocument(FileType,(data)=>{
        if(data && !data.error){
            downloadTermsandCondition(data?.link)
        }else{
            Notify(alert, "danger", data.error)
        }
})       
}
  



  return (
    <div className="dashboardPage keys">
      <NotificationAlert ref={alert} />
      <Container className="mt-4" fluid>
        <>
          <h5 className="mb-3">API Keys</h5>
          <div className="row justify-content-start">
            <div className=" col-lg-8 col-xl-7 col-xxl-6">
              <div className="card shadow-sm">
                <div className="card-body p-4 p-xl-5">
                  <p>
                    Link for API Documentation:{" "}
                    <a href="https://docs.ncentiva.com" className="text-dark">https://docs.ncentiva.com</a>
                  </p>
                  <div className="position-relative my-3">

                    <button className="btn btn-primaryTwo py-2  top-0 end-0" onClick={generateCredentials} disabled={credentialLoader}>
                      {credentialsOperation}
                    </button>
                  </div>
                  <h5 className="mb-3"> Description</h5>
                  <p>In this document, you can find all the requirements for Ncentiva API to access product catalogs and issue an order for digital gift card types. API endpoints are only accessible to customers who have credentials (a client ID and a secret key) provided by Ncentiva.</p>

                  <FormText className="text-muted">
                    By clicking on generate key you accept the <Link to={"terms"} onClick={() => downloadFile('TERMS')} style={{cursor:"pointer"}}> terms of Use </Link> and <Link to={"privacy"} onClick={() => downloadFile('PRIVACY')} style={{cursor:"pointer"}}>privacy policy.</Link>
                  </FormText>
                </div>

              </div>

            </div>
          </div>

          <Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="lg">
            <ModalHeader className="custom_header_colourTwo d-flex align-items-center justify-content-between " toggle={toggle}><h4 className='mb-0' style={{color:"white"}}>Save your new API Key</h4></ModalHeader>
            <ModalBody>
              <h4>Did you save your API Key and API Key Secret?</h4>
              <ul>
                <li>Save them in a secure location</li>
                <li>Treat them like a password or a set of keys</li>
                <li>If security has been compromised, regenerate them</li>
                <li>DO NOT store them in public places or shared docs</li>
              </ul>

              <Row className='mx-4'>
                <Col md={10}>
                  <Row>
                    <Col>
                      <h4>Access key</h4>
                    </Col>
                  </Row>

                  <Row className='bg-secondary my-3 py-3 justify-content-between'>
                    <Col md={6} xs={12} className="d-flex flex-column align-items-start flex-wrap">
                        <p className='my-2' style={{ wordBreak: 'break-all' }}>{access}<Button color='link' id="copyAccess" onClick={copyAccess}><i className="fas fa-copy"></i></Button></p>
                    </Col>
                    {/*<Col sm="auto">
                        <Button color='link' id="copyAccess" onClick={copyAccess}><i className="fas fa-copy"></i></Button>
                    </Col>*/}
                  </Row>

                  <Row>
                    <Col>
                      <h4>Secret</h4>
                    </Col>
                  </Row>
                  <Row className='bg-secondary my-3 py-3 justify-content-between'>
                    <Col md={6} xs={12} className="d-flex flex-column align-items-start flex-wrap">
                      <p className='my-2' style={{ wordBreak: 'break-all' }}>{secretKey}<Button color='link' id="copyAccess" onClick={copy}><i className="fas fa-copy"></i></Button></p>
                    </Col>
                    {/* <Col sm="auto">
                        <Button color='link' id="copySecret" onClick={copy}><i className="fas fa-copy"></i></Button>
                      </Col>*/}
                  </Row>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button type="button" color="secondary" onClick={toggle}>Close</Button>{' '}
            </ModalFooter>
          </Modal>
        </>
      </Container>

      <Modal isOpen={confirmModal} toggle={toggleConfirm} centered={true} backdrop="static">
        <ModalHeader className=" custom_header_colourTwo" toggle={toggleConfirm}></ModalHeader>
        <ModalBody className='text-center'>
          <p className="card-just-text">
            Are you sure you want to Regenerate your credentials........?
          </p>
          <p><span className=''>If you regenerate, you might need to update your code for your App to work properly.</span></p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
          <Button className='btn btn-primaryTwo' onClick={confirmRegeneration} disabled={generateLoader}>Yes, regenerate{
            generateLoader && 
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{
            margin: "0px 8px"
            }}
          />
            }</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Keys;